'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var trProductsMultipleView = exports.trProductsMultipleView = {
	Eol: {
		NotAvailable: {
			FR: 'Ce produit n\'est plus disponible',
			DE: 'Dieses Produkt ist leider nicht mehr verf\xFCgbar.',
			EN: 'This product is no longer available.'
		},
		Remaining: {
			FR: 'Liquidation! Il y a seulement une quantit\xE9 limit\xE9e du produit disponible.',
			DE: 'Restposten! Es ist nur noch eine begrenzte Menge des Produktes verf\xFCgbar.',
			EN: 'Remaining stock! There is only a limited quantity available.'
		}
	},
	VisibleProductCount: {
		DE: 'Artikel pro Seite',
		EN: 'Products per page',
		FR: 'Produits par page'
	},
	Filter: {
		Subcategory: {
			DE: 'Aktuelle Kategorie',
			EN: 'Current category',
			FR: 'Catégorie actuelle'
		},
		AvailableOnly: {
			Label: {
				DE: 'Anzeigen',
				EN: 'Show',
				FR: 'Afficher'
			},
			On: {
				DE: 'Verfügbare',
				EN: 'Available',
				FR: 'Disponible'
			},
			Off: {
				DE: 'Alle',
				EN: 'All',
				FR: 'Tous'
			}
		}
	},
	Sort: {
		Created: {
			Descending: {
				FR: 'le plus récent en premier',
				DE: 'Neuste zuerst',
				EN: 'Newest first'
			}
		},
		Price: {
			Descending: {
				FR: 'Prix : d\xE9croissant',
				DE: 'Preis: absteigend',
				EN: 'Price, descending'
			},
			Ascending: {
				FR: 'Prix : croissant',
				DE: 'Preis: aufsteigend',
				EN: 'Price, ascending'
			}
		},
		Availability: {
			FR: 'Disponibilit\xE9',
			DE: 'Verf\xFCgbarkeit',
			EN: 'Availability'
		},
		SearchResult: {
			FR: 'Meilleur résultat',
			DE: 'Bestes Ergebnis',
			EN: 'Best result'
		},
		Sortby: {
			FR: 'Trier par',
			DE: 'Sortierung',
			EN: 'Sorty by'
		}
	},
	View: {
		DE: 'Ansicht',
		EN: 'View'
	},
	Hits: {
		DE: '{AMOUNT} von {MAXHITS} Treffern',
		EN: '{AMOUNT} of {MAXHITS} Hits',
		FR: '{AMOUNT} de {MAXHITS} Hits'
	}

};